import { memo } from "react";
import { ScreenComponent } from "app/navigation/types";

export const memoizeScreen = (Component: any): ScreenComponent =>
  memo(Component, () => true);
